import { Controller } from '@hotwired/stimulus';

// Sélection de lignes d'une liste (TableComponent) : une fiche a une case
// dans le tableau et une dans sa carte (téléphone), tenues ensemble ; la
// barre d'action apparaît dès qu'une fiche est cochée, avec leur nombre ; la
// case de l'en-tête coche ou décoche les fiches affichées de la page
// (lignes masquées par un filtre exclues) ; « Tout cocher » et « Tout
// décocher » ; nom compté (cible `noun`) au singulier ou au pluriel,
// « sélectionnées » au féminin (`feminine`). Lignes rechargées (recherche,
// ligne remplacée par un Turbo Stream) : décompte refait.
export default class extends Controller {
    static targets = ['item', 'all', 'bar', 'count', 'total', 'noun'];

    static values = { feminine: Boolean };

    connect() {
        this.connected = true;
        this.update();
    }

    disconnect() {
        this.connected = false;
    }

    itemTargetConnected() {
        if (this.connected) this.update();
    }

    itemTargetDisconnected() {
        if (this.connected) this.update();
    }

    update(event) {
        const changed = event?.target;
        if (changed && this.itemTargets.includes(changed)) {
            this.itemTargets.filter((item) => item.value === changed.value).forEach((item) => { item.checked = changed.checked; });
        }
        const values = new Set(this.itemTargets.filter((item) => item.checked).map((item) => item.value));
        const pages = new Set(this.visibleItems().map((item) => item.value));
        const size = values.size;
        this.barTarget.hidden = size === 0;
        this.countTarget.textContent = `${size} sélectionné${this.feminineValue ? 'e' : ''}${size > 1 ? 's' : ''}`;
        this.totalTarget.textContent = String(size);
        this.nounTargets.forEach((noun) => { noun.textContent = size > 1 ? noun.dataset.plural : noun.dataset.singular; });
        this.allTargets.forEach((all) => {
            all.checked = size > 0 && size === pages.size;
            all.indeterminate = size > 0 && size < pages.size;
        });
    }

    toggleAll(event) {
        this.visibleItems().forEach((item) => { item.checked = event.target.checked; });
        this.update();
    }

    selectAll() {
        this.itemTargets.forEach((item) => { item.checked = true; });
        this.update();
    }

    clear() {
        this.itemTargets.forEach((item) => { item.checked = false; });
        this.update();
    }

    visibleItems() {
        return this.itemTargets.filter((item) => !item.closest('[hidden]'));
    }
}
